import { request } from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getHRSettings(id) {
    return await request('/api/hr-settings/{id}' + id);
}

export async function updateHRSettings(data) {
    return await request('/api/hr-settings/{id}', data, HttpMethod.PUT);
}